// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingBlockSpin_wrapper__E4awR","show":"LoadingBlockSpin_show__k8FeZ"};